import { createClient } from '@/shared/api';
import type {
  ClinicDataFilter,
  GetClinicDataQuery,
  GetClinicDataQueryVariables,
} from '@/shared/api';
import CLINIC_DATA_QUERY from '../queries/clinicData';

/**
 * Loads the ECG waveform window of a clinic study through the getClinicData query. Throws the returned message when the query reports failure and otherwise yields the start and stop bounds together with the ECG data map.
 *
 * @param filter - Filter selecting the clinic data window.
 * @returns A promise resolving to the start and stop bounds and the ECG data map.
 */
const fetchClinicData = async (filter: ClinicDataFilter) => {
  const client = createClient();
  const clinicDataResult = await client.query<GetClinicDataQuery, GetClinicDataQueryVariables>({
    query: CLINIC_DATA_QUERY,
    variables: {
      filter,
    },
  });
  const { data } = clinicDataResult;
  const { getClinicData } = data;
  if (!getClinicData.isSuccess) {
    throw new Error(getClinicData.message ?? undefined);
  }
  return {
    start: getClinicData.start,
    stop: getClinicData.stop,
    ecgDataMap: getClinicData.ecgDataMap,
  };
};

export default fetchClinicData;
